import { DamoAuthEnvironment } from './damoauth.environment';
import packageInfo from '../../../../package.json';

export const environment: DamoAuthEnvironment = {
  name: 'dev',
  firebase: {
    apiKey: 'AIzaSyCf98rVO8dC0PWCsxT94CBQTiBxVHggU2A',
    authDomain: 'dev-damotech-platform.firebaseapp.com',
    databaseURL: 'https://dev-damotech-platform.firebaseio.com',
    projectId: 'dev-damotech-platform',
    storageBucket: 'dev-damotech-platform.appspot.com',
    messagingSenderId: '316911716275',
    appId: '1:316911716275:web:de3917e3bf79ef3610edc6',
    measurementId: 'G-2VTPRL02JM',
  },
  fns: 'https://platform-dev.2totems.com/api',
  fnsOrigin: 'https://dev-damoauth.web.app',
  domain: '.2totems.com',
  postLoginRedirectUrl: 'https://platform-dev.2totems.com',
  target: 'hosting',
  sentry: {
    dsn: 'https://d50f63dd5efb868d3af5d08fb69c1571@o509349.ingest.us.sentry.io/4511469465829376',
    release: `damoauth@${packageInfo.version}`,
  },
};
